import { useState } from 'react'

// PAGES
import Home from './components/home/Home'
import Login from './components/login/Login'
import Logout from './components/logout/Logout'
import Preview from './components/Preview'
import Talent from './components/Talent'
import Controls from './components/Controls'

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

export default function App() {

  const [gameUrl, setGameUrl] = useState('')

  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Home setGameUrl={setGameUrl} />
        </Route>

        <Route exact path="/talent">
          <Talent gameUrl={gameUrl} />
        </Route>

        <Route path="/login" component={Login} />
        <Route path="/preview" component={Preview} />
        <Route path="/controls" component={Controls} />
      </Switch>
    </Router>
  );
}
